module.exports = __webpack_public_path__ + "img/playstore.7649226e.png";